import { weekDays, weekNumber, dayKey } from '../data/activity';
import { useSwipe } from '../hooks/useSwipe';

const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function Item({ lead, onOpen, onLogVisit }) {
  return (
    <div className="agenda-item" onClick={() => onOpen(lead.id)}>
      <div><b>{lead.businessName}</b><div style={{ fontSize: 'var(--text-caption)', color: 'var(--color-fg-muted)' }}>{lead.stage} · {lead.category}</div></div>
      <button className="btn btn-ghost btn-sm" onClick={(e) => { e.stopPropagation(); onLogVisit(lead.id); }}>Log</button>
    </div>
  );
}

function DaySection({ date, leads, onOpen, onLogVisit }) {
  return (
    <div className="day-section">
      <div className="day-head">{DOW[date.getDay()]} {date.getDate()}</div>
      {leads.length === 0
        ? <div className="day-empty">Nothing scheduled</div>
        : leads.map((l) => <Item key={l.id} lead={l} onOpen={onOpen} onLogVisit={onLogVisit} />)}
    </div>
  );
}

// mode: 'day' | 'week'. cursor: Date. leadsOn(date) -> lead[]. shift(n) moves the cursor.
export default function MobileAgenda({ mode, cursor, leadsOn, shift, onOpen, onLogVisit }) {
  const swipe = useSwipe({ onNext: () => shift(1), onPrev: () => shift(-1) });
  const days = mode === 'week' ? weekDays(cursor) : [cursor];
  return (
    <div className="agenda" {...swipe} data-testid="mobile-agenda" data-week={weekNumber(cursor)}>
      {days.map((d) => (
        <DaySection key={dayKey(d.getTime())} date={d} leads={leadsOn(d)} onOpen={onOpen} onLogVisit={onLogVisit} />
      ))}
    </div>
  );
}
